/* =====================================================================
   BeezFy — Box "Paga a rate" (PDP)
   Aggiorna l'importo della singola rata al cambio variante e tiene
   allineato il componente nativo <shopify-payment-terms>.
   L'apertura/chiusura del dettaglio è nativa (<details>): zero JS.
   Doc: docs/PAGA-A-RATE.md
   ===================================================================== */
(function () {
  'use strict';

  // Separatori migliaia/decimali secondo il placeholder usato da Shopify,
  // così la rata è formattata ESATTAMENTE come gli altri prezzi del sito.
  function withSeparators(cents, decimals, thousands, decimal) {
    var value = (cents / 100).toFixed(decimals);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return decimals > 0 ? parts.join(decimal) : parts[0];
  }

  function formatMoney(cents, format) {
    var fmt = format || (window.theme && window.theme.moneyFormat) || (window.Shopify && window.Shopify.money_format) || '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, fmt); } catch (e) { /* fallback sotto */ }
    }

    if (!fmt) return '€' + withSeparators(cents, 2, '.', ',');

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withSeparators(cents, 2, ',', '.');
        case 'amount_no_decimals': return withSeparators(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withSeparators(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSeparators(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSeparators(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withSeparators(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return withSeparators(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return withSeparators(cents, 2, ' ', '.');
        default: return withSeparators(cents, 2, '.', ',');
      }
    });
  }

  function perInstallment(price, parts) {
    if (!parts || parts < 2) return price;
    // Arrotondamento per ECCESSO: mai mostrare una rata più bassa del reale
    return Math.ceil(price / parts);
  }

  function ranges(root) {
    try { return JSON.parse(root.getAttribute('data-ranges') || '{}'); } catch (e) { return {}; }
  }

  // Come i widget ufficiali: ogni provider ha la sua fascia d'importo e si
  // nasconde da solo quando il prezzo ne è fuori. Ritorna quanti restano visibili.
  function applyEligibility(root, price) {
    var rs = ranges(root);
    var visible = 0;

    Object.keys(rs).forEach(function (key) {
      var min = rs[key][0] || 0;
      var max = rs[key][1] || 0;
      var ok = price >= min && (max <= 0 || price <= max);
      if (ok) visible++;
      var nodes = root.querySelectorAll('[data-provider="' + key + '"]');
      Array.prototype.forEach.call(nodes, function (n) { n.hidden = !ok; });
    });

    return visible;
  }

  // silent = non riscrivere il testo: all'avvio l'importo è già stato reso da Liquid
  // con il formato valuta del negozio, non va sovrascritto dal formatter JS.
  function update(root, price, silent) {
    if (!root || typeof price !== 'number' || isNaN(price)) return;

    var parts = parseInt(root.getAttribute('data-parts'), 10) || 3;
    var min = parseInt(root.getAttribute('data-min-price'), 10) || 0;
    var format = root.getAttribute('data-money-format') || '';

    var eligible = applyEligibility(root, price);

    // Prezzo zero, sotto il pavimento globale, o nessun provider idoneo → via il box
    if (price <= 0 || (min > 0 && price < min) || eligible === 0) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    root.setAttribute('data-unit-price', String(price));

    if (silent) return;
    var amountEl = root.querySelector('[data-installments-amount]');
    if (amountEl) amountEl.textContent = formatMoney(perInstallment(price, parts), format);
  }

  function syncNative(root, variantId) {
    if (!variantId) return;
    var terms = root.querySelector('shopify-payment-terms');
    if (terms && String(terms.getAttribute('variant-id')) !== String(variantId)) {
      terms.setAttribute('variant-id', String(variantId));
    }
  }

  function roots(context) {
    var sel = context ? '[data-installments][data-context="' + context + '"]' : '[data-installments]';
    return document.querySelectorAll(sel);
  }

  // Il cambio variante riguarda SOLO il box della scheda prodotto: quello del
  // carrello lavora sul totale, non sul prezzo del capo che stai guardando.
  function onVariantChanged(event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant) return;
    Array.prototype.forEach.call(roots('product'), function (root) {
      update(root, variant.price);
      syncNative(root, variant.id);
    });
  }

  // Carrello: gli eventi del tema sono incoerenti (cart:update / cart:updated /
  // cart:item-added, spesso senza detail) → rileggo il totale da /cart.js.
  var cartTimer = null;
  function refreshCart() {
    var list = roots('cart');
    if (!list.length) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(list, function (root) { update(root, cart.total_price); });
      })
      .catch(function () { /* il box resta com'è: mai numeri inventati */ });
  }
  function scheduleCartRefresh() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(refreshCart, 120);
  }

  // Il tema emette entrambi gli eventi (beezfy-product-premium.js)
  document.addEventListener('variant:changed', onVariantChanged);
  document.addEventListener('beezfy:variant:changed', onVariantChanged);

  ['cart:update', 'cart:updated', 'cart:item-added', 'cart:add', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, scheduleCartRefresh);
    window.addEventListener(ev, scheduleCartRefresh);
  });

  // Rete di sicurezza: alcuni flussi (wizard varianti, deep-link ?variant=)
  // aggiornano solo l'input nascosto senza emettere eventi.
  function watchVariantInput() {
    var input = document.querySelector('[data-product-form] [data-variant-id]');
    if (!input || !window.MutationObserver) return;
    var last = input.value;
    var check = function () {
      if (input.value === last) return;
      last = input.value;
      var data = window.beezfyProductData || (window.theme && window.theme.product);
      var variants = (data && data.variants) || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(input.value)) {
          Array.prototype.forEach.call(roots(), function (root) {
            update(root, variants[i].price);
            syncNative(root, variants[i].id);
          });
          break;
        }
      }
    };
    new MutationObserver(check).observe(input, { attributes: true, attributeFilter: ['value'] });
    document.addEventListener('change', check, true);
  }

  function init() {
    Array.prototype.forEach.call(roots(), function (root) {
      update(root, parseInt(root.getAttribute('data-unit-price'), 10), true);
    });
    watchVariantInput();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
